export type DotStepperProps = {
  count: number;
  current: number;
};
export function DotStepper(props: DotStepperProps) {
  const dots = Array.from({ length: props.count }, (_v, index) => index + 1);
  return (
    <div className="flex gap-3">
      {dots.map(function (v) {
        return (
          <div
            key={v}
            className={`size-2 rounded-md ${v === props.current ? 'bg-branding-accent' : 'bg-branding-accent-100'}`}
          ></div>
        );
      })}
    </div>
  );
}
